import React, { createContext, useContext } from 'react';

import { LOCALE, LocaleType } from '@strava/constants';

export interface CldrContext {
  calendar: {
    weekdays: (...args: unknown[]) => unknown;
  };
  formatCurrency: (...args: unknown[]) => unknown;
  formatDateTime: (...args: unknown[]) => unknown;
  formatDecimal: (...args: unknown[]) => unknown;
  formatTimespan: (...args: unknown[]) => unknown;
}

export type tFunction = (
  key: string | string[],
  config?: Record<string, unknown>
) => string;

export interface TranslationContextValue {
  t: tFunction;
  getLanguage: () => LocaleType;
  // Available in MFEs
  Cldr?: CldrContext;
}

export const TranslationContext = createContext<TranslationContextValue | null>(
  null
);

export const useStravaTranslations = () => {
  const context = useContext(TranslationContext);

  if (!context) {
    throw new Error(
      'useStravaTranslationContext must be used within a TranslationProvider'
    );
  }

  return context;
};

export interface TranslationProviderProps
  extends Partial<TranslationContextValue> {
  children: React.ReactNode;
}

export const TranslationProvider = ({
  children,
  ...translationContextValue
}: TranslationProviderProps) => {
  return (
    <TranslationContext.Provider
      value={{
        getLanguage: () => LOCALE.enUS,
        t: (key) => `${key}`,
        ...translationContextValue
      }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

if (process.env.NODE_ENV === 'development') {
  TranslationProvider.displayName = 'TranslationProvider';
}
